import {
  CREATE_PREVENTIVE_MAINTENANCE_SUCCESS,
  FETCH_PREVENTIVE_MAINTENANCE_LAST_PROCESSED_SUCCESS,
  FETCH_PREVENTIVE_MAINTENANCE_SUCCESS,
  GET_PREVENTIVE_MAINTENANCE_SUCCESS,
  PREVENTIVE_MAINTENANCE_PROCESS_SUCCESS,
  PREVENTIVE_MAINTENANCE_TASK_UPDATE_SUCCESS,
  SAVE_PREVENTIVE_MAINTENANCE_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  lastProcessedResource: null,
  taskUpdateData: null,
  isProcessDone: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_PREVENTIVE_MAINTENANCE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_PREVENTIVE_MAINTENANCE_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_PREVENTIVE_MAINTENANCE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_PREVENTIVE_MAINTENANCE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_PREVENTIVE_MAINTENANCE_LAST_PROCESSED_SUCCESS: {
      return {
        ...state,
        lastProcessedResource: action.data,
      }
    }

    case PREVENTIVE_MAINTENANCE_TASK_UPDATE_SUCCESS: {
      return {
        ...state,
        taskUpdateData: action.data,
      }
    }

    case PREVENTIVE_MAINTENANCE_PROCESS_SUCCESS: {
      return {
        ...state,
        isProcessDone: action.data,
      }
    }

    default:
      return state;
  }
}
